import { render, staticRenderFns } from "./NewFilterItemsCheckboxOptions.vue?vue&type=template&id=21255492&"
import script from "./NewFilterItemsCheckboxOptions.vue?vue&type=script&lang=js&"
export * from "./NewFilterItemsCheckboxOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports